import { SessionKeys, setSessionStorage } from '@flowus/common/storage';
import { SingleInput } from '@flowus/common/uikit/single-input';
import type { FC } from 'react';
import { useCallback, useEffect, useState } from 'react';
import { IconWidget } from 'src/common/components/emoji-widget';
import { request } from 'src/common/request';
import { Placeholder } from 'src/components/empty/placeholder';
import { useGetQuery } from 'src/hooks/page/use-get-query';
import { SearchParams } from 'src/utils';
import type { Header as Header0 } from '../main/header';

interface Props {
  uuid: string;
}
let Header: typeof Header0;
export const set_cycle_header = (component: typeof Header0) => {
  Header = component;
};

export const SharePasswordPage: FC<Props> = ({ uuid }) => {
  const [error, setError] = useState(false);
  const getQuery = useGetQuery();
  const password = getQuery(SearchParams.password);

  const success = useCallback(
    async (value: string) => {
      setSessionStorage(SessionKeys.PASSWORD, value);
      const res = await request.editor.getDoc.raw(uuid);
      if (res.code === 200) {
        localStorage.setItem(`share-psw-${uuid}`, value);
        location.reload();
        setError(false);
      } else {
        sessionStorage.clear();
        setError(true);
      }
    },
    [uuid]
  );

  useEffect(() => {
    if (password) {
      void success(password);
    }
  }, [password, success]);

  return (
    <>
      <Header emptyStyle />
      <Placeholder icon="🔐" title={<span className="text-h2">分享访问密码</span>}>
        <div className="flex my-2.5">
          <SingleInput
            size={4}
            success={success}
            onError={() => setError(true)}
            onChange={() => setError(false)}
          />
        </div>
        {error && (
          <div className="text-t2 text-red flex">
            <IconWidget emojiStr="⚠️" className="mr-1" />
            密码错误
          </div>
        )}
      </Placeholder>
    </>
  );
};
